import Repository from '@/libs/axios'
import OperationRepository from '@/libs/customAxios/operationAxios'

// const resource = '/merchant/resource'

export default {
  getCountryList() {
    return OperationRepository.get('country?noPagination')
  },
  getStateListByID(countryID) {
    return OperationRepository.get(`/country/${countryID}/state`)
  },
  getCityListByID(stateID) {
    return OperationRepository.get(`/state/${stateID}/city`)
  },
  setMerchant(payload) {
    return Repository.post('/merchant/registration', payload)
  },
  getActiveTermsAndCondition() {
    return OperationRepository.get('/merchant/active-terms-and-condition')
  },
  updateVerificationDocuments(formData) {
    return Repository.post('/merchant/verification-doc-upload', formData)
  },
  getConfiguration() {
    return Repository.get('/merchant/registration-form/configuration')
  },
}
